import { FC } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

import { LAYOUT_VERTICAL_PADDING } from 'layouts/ContentLayout/constants';

// avoid cards' shadow overflowing around on scroll
const SAFE_AREA = 'space-12';

const StickyHeader: FC<FlexProps> = (props) => (
  <Flex
    alignItems="center"
    backgroundColor="white"
    gap="space-16"
    justifyContent="space-between"
    marginX={`-${SAFE_AREA}`}
    paddingBottom="space-40"
    paddingTop="space-20"
    paddingX={SAFE_AREA}
    position="sticky"
    top={`-${LAYOUT_VERTICAL_PADDING}`}
    zIndex={10} // avoid overlaps
    {...props}
  />
);

export default StickyHeader;
